<template>
  <div class="lime-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
          <div class="row">
      </div>
        </div>
      </div>
      
    </div>
    <div id="createInvoice">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <flash-message class="myCustomClass"></flash-message>
            <h5 class="modal-title" id="exampleModalLabel">Create Invoice</h5>
            <button type="button" class="close" id="invoiceClose"  @click="$emit('close')" data-dismiss="modal" aria-label="Close">
              <i class="material-icons">close</i>
            </button>
          </div>
          <form>
            <div class="modal-body">
            <p style="color:red;text-align:center">{{ errorMessage }}</p>
              <p v-if="errors.length">
                <!-- <ul>
                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                </ul> -->
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <select class="form-control" id="brandid" ref="brandid" name="brandid" v-model="input.brandid" @change="changeBrand($event)">
                      <option value="" selected>Select Brand*</option>
                      <option v-for="(brand, index, key) in getBrandsAscendingOrder" :value="index">{{ brand.brand_name }}</option>
                    </select> 
                  </div>
                  <!-- <div class="custom-control custom-checkbox form-group">
                      <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()">
                      <label class="custom-control-label" for="termsandcond">Escrow</label>
                  </div> -->
                  <div class="form-group" >
                      <select class="form-control" ref="duedays" v-model="input.duedays" @change="changeDays($event)" >
                         <option value=""  >Payment Term*</option>
                          <option v-for="dueday in duedaysList"  v-bind:value="dueday.value">
                     
                        {{ dueday.text }}

                       </option>
                    </select>
                  </div>
                  <div class="form-group" >
                    <select   id="immediateHeldSelect" ref="invoicetype" class="form-control" v-model="input.invoicetype"  name="invoicetype" @change="invoiceType($event)">
                        <option value="" selected>Invoice Type*</option> 
                      <option v-for="option in invoicetypeList" v-bind:id="option.id"  v-bind:value="option.value">
                        {{ option.text }}

                       </option>
                    </select>
                  </div>
                         
                  <div id="" v-for="(brand, index, key) in brands">
                    <div class="brand-detail"  v-if="index === selectedBrand">
                      <div class="brand-logo" id="brand-logo">
                        <img v-bind:src="brand.brand_logo" >
                      </div>
                      <ul id="brandDetail">
                        <li>
                          <i class="material-icons">language</i>
                          <span> {{brand.brand_name}}</span>
                        </li>
                        <li>
                          <i class="material-icons">mail</i>
                          <span> {{brand.site_url}}</span>
                        </li>
                        <li>
                          <i class="material-icons">phone</i>
                          <span> {{brand.contact_no}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" class="form-control" id="amount" ref="amount"  name="amount" v-model="input.amount" placeholder="Enter Amount*" />
                  </div>
                  <div class="form-group">
                    <textarea class="form-control" id="description" ref="description" name="description" v-model="input.description" placeholder="Description*">
                                            </textarea>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" ref="admin" id="admin" name="admin" v-model="input.admin" @change="changeAdmin($event)">
                          <option value="" selected>Select Escrow*</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.user_type === 'escrow' && user.role === 'user' && user.status === 'active' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select> 
                        <!-- <span style="float:right;margin-top:10px">Escrow</span> -->
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="adminpercent" id="adminpercent" name="adminpercent" v-model="input.adminpercent" placeholder="00.00%*" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" id="userA" ref="userA" name="userA" v-model="input.userA" @change="changeUserFirst($event)" >
                          <option value="" selected>User A*</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userApercent" id="userApercent" name="userApercent" v-model="input.userApercent" placeholder="00.00%*" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" id="userB" ref="userB" name="userB" v-model="input.userB" @change="changeUserSecond($event)">
                          <option value="" selected>User B</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active' && user.uid !== selecteduserA ">{{ user.firstname }} {{ user.lastname }} <{{ user.email}}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userBpercent" id="userBpercent" name="userBpercent" v-model="input.userBpercent" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" id="userC" ref="userC" name="userC" v-model="input.userC" @change="changeUserThird($event)">
                          <option value="" selected>User C</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.user_type === 'user' && user.status === 'active' && user.platform_payments === 'active' && user.uid !== selecteduserA && user.uid !== selecteduserB ">{{ user.firstname }} {{ user.lastname }} <{{ user.email}}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userCpercent" id="userCpercent" name="userCpercent" v-model="input.userCpercent" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <i>The total Split (%) should add up to 100% (Mandatory)</i>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" id="draft" class="btn btn-secondary" data-dismiss="modal" v-on:click="draftInvoice()">Save as Draft</button>
              <button type="button" id="save" class="btn btn-primary" v-on:click="saveInvoice()">Save and Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import invoiceAction from './invoiceAction'
import AddInvoice from './AddInvoice'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
require('vue-flash-message/dist/vue-flash-message.min.css')
export default {
  name: 'Invoice',
  components: { AddInvoice,
    Loading
  },
  data () {
    return {
      msg: '',
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      tblCls: 'table',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      getBrandsAscendingOrder: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      invoiceDetails: {
        InvoiceData: {
          amount: '',
          description: '',
          uid: '',
          invoice_percentage_id: '',
          brand_id: ''
        },
        invoicePercentageData: {
          admin_percentage: '',
          userA_percentage: '',
          userB_percentage: '',
          userC_percentage: '',
          admin_id: '',
          userA_id: '',
          userB_id: '',
          userC_id: ''
        }
      },
      invoicetypeList: [{
                id: 'immediate',
                  text: 'Immediate',
                value: 'immediate'
              }, {
                text: 'Held',
                value: 'held',
                 id: 'held'
              }],
        duedaysList:[{
                text: 'Escrow',
                value: '1'
              }, {
                text: '15 Days',
                value: '15'
              }, {
                text: '30 Days',
                value: '30'
              }, {
                text: '45 Days',
                value: '45'
              }, {
                text: '60 Days',
                value: '60'
              }],
      input: {
        brandid: '',
        amount: '',
        admin: '',
        description: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        invoicetype: '',
         duedays: '',
        
        onedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: '',
      columns: [
        {label: 'Stripe Invoice ID', field: 'id'},
        {label: 'Brand', field: 'brand_name'},
        {label: 'Payment ($)', field: 'amount', headerClass: 'class-in-header second-class'},
        {label: 'Ghost (%)', field: 'admin_percentage'},
        {label: 'User A (%)', field: 'userA_percentage'},
        {label: 'User B (%)', field: 'userB_percentage'},
        {label: 'User C (%)', field: 'userC_percentage'},
        {label: 'Status',
          field: 'status',
          interpolate: true,
          representedAs: function (row) {
            if (row.status === 'open') {
              return ` <span style="color:red">${row.status}</span> `
            } else if (row.status === 'draft') {
              return ` <span style="color:blue">${row.status}</span> `
            } else {
              return ` <span style="color:green">${row.status}</span> `
            }
          }
        },
        {label: 'Action',
          component: invoiceAction,
          sortable: false
        }
      ],
      rows: this.invoicesList,
      filter: '',
      page: 1
    }
  },
  methods: {     
 
    invoiceBtn () {
      var modal = document.getElementById('createInvoice')
      modal.style.display = 'block'
    },
    invoiceClose () {
      this.input.amount = ''
      this.input.description = ''
      this.input.adminpercent = ''
      this.input.userApercent = ''
      this.input.userBpercent = ''
      this.input.userCpercent = ''
      this.input.brandid = ''
      this.input.admin = ''
      this.input.userA = ''
      this.input.userB = ''
      this.input.userC = ''
      this.input.duedays = ''
      this.input.onedays = ''
      document.getElementById('brand-logo').style.display = 'none'
      document.getElementById('brandDetail').style.display = 'none'
      document.getElementById('userApercent').disabled = true
    },
    adUser () {
      this.$modal.show(AddInvoice, { height: '100%' })
    },
    createInvoicePopup () {
      var modal = document.getElementById('createInvoice')
      var span = document.getElementById('invoiceClose')
      span.onclick = function () {
        modal.style.display = 'none'
        document.getElementById('userApercent').disabled = true
        document.getElementById('userBpercent').disabled = true
        document.getElementById('userCpercent').disabled = true
      }
      window.onclick = function (event) {
        if (event.target === modal) {
          modal.style.display = 'none'
        }
      }
    },
    changeBrand (event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value
      console.log(this.selectedBrand)
    },
    changeDays (event) { 
       let optionList= document.getElementById("immediateHeldSelect");
       console.log(optionList.value)
       let display = "block"
       let selected = ""
      if (this.input.duedays === '1') {
             display = "none"
             selected="true"
      }else {
         // alert('1')
        selected=""
        this.input.invoicetype = ""
      }
      for (let i = 0; i < optionList.length; i++) {
                  if (optionList.options[i].value === 'immediate') {
                      optionList.options[i].style.display = display

                   } 
                   if (optionList.options[i].value === 'held') {
                    // alert('2')
                      this.input.invoicetype = 'held'
                      optionList.options[i].selected=selected
                   } 
              } 
     
    },
    invoiceType (event){
      this.invoiceType = event.target.options[event.target.options.selectedIndex].value
     
    },
    changeUserFirst () {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value
      //alert(this.selecteduserA)
      if (this.selecteduserA === '')
      {
        this.input.userApercent = '' 
        this.input.userBpercent = ''
        this.input.userCpercent = ''
        this.input.userB = ''
        this.input.userC = ''
        document.getElementById('userB').disabled = true
        document.getElementById('userC').disabled = true
        document.getElementById('userApercent').disabled = true
        document.getElementById('userBpercent').disabled = true
        document.getElementById('userCpercent').disabled = true

      } else {
        // alert('1')
        document.getElementById('userB').disabled = false
        document.getElementById('userApercent').disabled = false   
      }
    },
    changeUserSecond () {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value
      if (this.selecteduserB === '')
      {
        this.input.userBpercent = ''
        this.input.userCpercent = ''
        this.input.userB = ''
        this.input.userC = ''
        document.getElementById('userC').disabled = true
        document.getElementById('userBpercent').disabled = true
        document.getElementById('userCpercent').disabled = true

      } else {
        document.getElementById('userC').disabled = false
        document.getElementById('userBpercent').disabled = false   
      }
    },
    changeUserThird () {
      this.selecteduserC = event.target.options[event.target.options.selectedIndex].value
      if (this.selecteduserC === '')
      {
        this.input.userCpercent = ''
        document.getElementById('userCpercent').disabled = true
      } else {
        document.getElementById('userCpercent').disabled = false   
      }
    },
    getBrands () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.brands = response.data.results
          
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getUsers () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.users = response.data.results
          console.log(this.users)
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.invoices = response.data.results
          for (var i in this.invoices) {
            var obj = this.invoices[i]
            var amount = Number(obj.amount).toLocaleString()
            this.invoicesList.push({
              id: obj.stripe_invoice_id,
              uid: obj.invoice_id,
              amount: amount,
              brand_name: obj.brand_name,
              admin_percentage: obj.admin_percentage,
              userA_percentage: obj.userA_percentage,
              userB_percentage: obj.userB_percentage,
              userC_percentage: obj.userC_percentage,
              status: obj.status,
              invoice_type: obj.invoice_type
            })
            this.isLoading = false
          }
        })
        .catch((error) => {
          console.log(error.response.data.errors)
          this.isLoading = false
        })
    },
    showInvoice (invoiceId) {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          console.log(response)
          this.isLoading = false
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    saveInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      this.errors = []
      var status = 'open'
      var amount = this.input.amount
      var description = this.input.description
      var adminpercent = this.input.adminpercent
      var userApercent = this.input.userApercent
      var userBpercent = this.input.userBpercent ? this.input.userBpercent : 0.00
      var userCpercent = this.input.userCpercent ? this.input.userCpercent : 0.00
      var brandId = this.input.brandid
      var escrowUserId  = this.input.admin
      var userA = this.input.userA
      var userB = this.input.userB
      var userC = this.input.userC
      var duedays = this.input.duedays
      var onedays = this.input.onedays
      var invoiceType = this.input.invoicetype
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) +  + parseFloat(userCpercent)
      var numbersOnly = /^\d+$/
      if (brandId === '') {
        this.errors.push('Brand is Required')
        this.$refs.brandid.focus()
      } else if (amount === '') {
        this.errors.push('Amount is Required')
        this.$refs.amount.focus()
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Please Enter Valid Amount')
        this.$refs.amount.focus()
      } else if (duedays === '') {
        this.errors.push('Due Days is Required')
        this.$refs.duedays.focus()
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required')
        this.$refs.invoicetype.focus()
      } else if (description === '') {
        this.errors.push('Description is Required')
        this.$refs.description.focus()
      } else if (escrowUserId === '') {
        this.errors.push('Admin is Required')
        this.$refs.admin.focus()
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required')
        this.$refs.adminpercent.focus()
      } else if (userA === '') {
        this.errors.push('UserA is Required')
        this.$refs.UserA.focus()
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required')
        this.$refs.userApercent.focus()
      } else if (total !== 100) {
        this.errors.push('Total should be 100')
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id : escrowUserId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          due_days: duedays,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            console.log(response)
            this.$eventBus.$emit('listInvoice', 'Invoice created successfully');
            this.$eventBus.$emit('latestDashbordList');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listInvoice', '','Invoice could not be Added');
              this.$eventBus.$emit('latestDashbordList');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
      }
    },
    draftInvoice () {
      this.errors = []
      var jwttoken = localStorage.getItem('jwt')
      var status = 'draft'
      var amount = this.input.amount
      var description = this.input.description
      var adminpercent = this.input.adminpercent
      var userApercent = this.input.userApercent
      var userBpercent = this.input.userBpercent ? this.input.userBpercent : 0
      var userCpercent = this.input.userCpercent ? this.input.userCpercent : 0
      var brandId = this.input.brandid
      var escrowUserId = this.input.admin
      var userA = this.input.userA
      var userB = this.input.userB
      var userC = this.input.userC
      var duedays = this.input.duedays
      var onedays = this.input.onedays
      var invoiceType = this.input.invoicetype
      
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent)
      
      var numbersOnly = /^\d+$/
      if (brandId === '') {
        this.errors.push('Brand is Required')
        this.$refs.brandid.focus()
      } else if (duedays === '') {
        this.errors.push('Due Days is Required')
        this.$refs.duedays.focus()
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required')
        this.$refs.invoicetype.focus()
      } else if (amount === '') {
        this.errors.push('Amount is Required')
        this.$refs.amount.focus()
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number')
        this.$refs.amount.focus()
      } else if (description === '') {
        this.errors.push('Description is Required')
        this.$refs.description.focus()
      } else if (escrowUserId === '') {
        this.errors.push('Admin is Required')
        this.$refs.admin.focus()
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required')
        this.$refs.adminpercent.focus()
      } else if (userA === '') {
        this.errors.push('UserA is Required')
        this.$refs.userA.focus()
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required')
        this.$refs.userApercent.focus()
      } else if (total !== 100) {
        this.errors.push('Total should be 100')
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/createInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: escrowUserId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          due_days: duedays,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.$eventBus.$emit('listInvoice', 'Invoice created successfully');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listInvoice', '','Invoice could not be Added');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
      }
    }
  },
  created () {
    this.getBrands()
    this.getUsers()
    this.getInvoice()
  },
  computed: {
    sortedArray: function() {
      function compare(a, b) {
        if (a.brand_name < b.brand_name)
          return -1;
        if (a.brand_name > b.brand_name)
          return 1;
        return 0;
      }

      return this.brands.sort(compare);
    }
  },
  mounted () {
    var jwttoken = localStorage.getItem('jwt')
    axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getListBrands', {
        headers: {
          'x-access-token': jwttoken
    }})
    .then(response => {
      this.isLoading = false
      this.getBrandsAscendingOrder = response.data.results
      console.log(this.getBrandsAscendingOrder)
    })
    .catch((error) => {
      this.errorMessage = error.response.data.errors
      this.isLoading = false
    })
    document.getElementById('userApercent').disabled = true
    document.getElementById('userBpercent').disabled = true
    document.getElementById('userCpercent').disabled = true
    document.getElementById('userB').disabled = true
    document.getElementById('userC').disabled = true
    var options = document.getElementById("duedays").options;
    this.createInvoicePopup()
  },
  watch: {
    $route (to, from) {
      this.msg = this.$router.currentRoute.query.errorMessage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddInvoice.vue